module.exports = __webpack_public_path__ + "static/media/50041.4193a12c.png";